import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a090d7c6"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "cg-header",
  class: "d-flex justify-content-between background",
  style: {"height":"35px"}
}
const _hoisted_2 = {
  id: "headline",
  class: "d-flex flex-row align-items-center justify-content-center",
  style: {"margin-left":"8px"}
}
const _hoisted_3 = { class: "breadcrumb" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "d-flex flex-row justify-content-center align-items-center" }
const _hoisted_6 = {
  class: "nav",
  style: {"height":"35px !important"}
}
const _hoisted_7 = { class: "nav-item" }
const _hoisted_8 = {
  class: "nav-item dropdown cursor",
  style: {"height":"35px !important"}
}
const _hoisted_9 = {
  class: "nav-link dropdown-toggle label a-class",
  "data-bs-toggle": "dropdown",
  role: "button",
  "aria-expanded": "false"
}
const _hoisted_10 = { class: "dropdown-menu font-size-12 custom-dropdown-menu" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", { class: "dropdown-divider" }, null, -1))
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { class: "dropdown-item a-class disabled" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  class: "nav-item dropdown cursor",
  style: {"height":"35px !important"}
}
const _hoisted_16 = {
  class: "nav-link dropdown-toggle label a-class",
  "data-bs-toggle": "dropdown",
  role: "button",
  "aria-expanded": "false"
}
const _hoisted_17 = { class: "dropdown-menu font-size-12" }
const _hoisted_18 = { class: "dropdown-item a-class" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_20 = { class: "dropdown-item disabled disabled-black a-class" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_22 = { class: "dropdown-item disabled disabled-black a-class" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_24 = { class: "dropdown-item disabled disabled-black" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("li", null, [
  /*#__PURE__*/_createElementVNode("hr", { class: "dropdown-divider" })
], -1))
const _hoisted_26 = { class: "dropdown-item a-class" }

import { computed, onBeforeMount, onMounted, ref, watch } from "vue";
import { ElTooltip, ElInput } from "element-plus";
import { currentRoute, router } from "@/core/router";
import {
  authInfo,
  isSelectedOrganizationRole,
  logout,
  setSelectedOrganizationRole,
} from "@/core/auth";
import i18n from "@/core/i18n/i18n";
import {
  organizationRoles,
  selectedOrganizationRole,
} from "@/core/auth/user-role";
import {
  selectedBreadcrumb,
  switchBreadcrumbListByRouteName,
} from "@/core/layout/index";
import { getParameter } from "@/core/util/env";
import { EventBus } from "@/eventBus";
import { showConfirm } from "@/core/popup";

const helpUrl = "https://docs.oneteg.com/";


export default /*#__PURE__*/_defineComponent({
  __name: 'Header',
  setup(__props) {

const { t } = i18n.global;
const oneTegVersion = ref("");
const selectedLanguage = ref("en");
const searchQuery = ref("");
const version = computed(() => oneTegVersion.value.split("-")[0]);

const sortedOrganizationRoles = computed(() =>
  // OT-4895: drop orphaned org-roles before sorting. The template dereferences
  // both organization.name and role.name, so require BOTH to be present; copy the
  // array with slice() so we don't mutate the source in place.
  organizationRoles.value
    .filter((role) => role && role.organization && role.role)
    .slice()
    .sort((a, b) => a.organization.name.localeCompare(b.organization.name))
);

const filteredOrganizationRoles = computed(() =>
  sortedOrganizationRoles.value.filter((organizationRole) =>
    organizationRole.organization.name
      .toLowerCase()
      .includes(searchQuery.value.toLowerCase())
  )
);

function splitRoute() {
  const getCurrentLanguage = currentRoute.value.path.split("/");
  if (getCurrentLanguage[1] === "en") {
    selectedLanguage.value = "english";
  } else {
    selectedLanguage.value = "turkish";
  }
}

function confirmAndExecute(action, confirmMessageTitle, confirmMessageBody) {
  const isCurrentRouteFlows = currentRoute.value.path.includes("/flows/");

  if (isCurrentRouteFlows && EventBus?.isAnyChange === true) {
    showConfirm("warning", confirmMessageTitle, confirmMessageBody).then(
      (confirmed) => {
        if (confirmed) {
          action();
        }
      }
    );
  } else {
    action();
  }
}

function handleChangeOrganization(organizationRole) {
  if (isSelectedOrganizationRole(organizationRole)) {
    setSelectedOrganizationRole(organizationRole);
    return;
  }
  confirmAndExecute(
    () => setSelectedOrganizationRole(organizationRole),
    t("Flow.UnsavedChanges"),
    t("Flow.UnsavedChangesMessage")
  );
}

function handleLogOut() {
  confirmAndExecute(
    logout,
    t("Flow.UnsavedChanges"),
    t("Flow.UnsavedChangesMessage")
  );
}
const isActive = ref(false);

watch(currentRoute, () => {
  checkActiveRoute();
});

function checkActiveRoute() {
  isActive.value = currentRoute.value.path.endsWith("/settings");
}

function goToSettings() {
  router.push("/settings");
}
onMounted(() => {
  checkActiveRoute();
  splitRoute();
  switchBreadcrumbListByRouteName(currentRoute.value.name as string);
  watch(
    () => currentRoute.value.path,
    () => {
      splitRoute();
    }
  );
  watch(
    () => currentRoute.value.name,
    () => {
      switchBreadcrumbListByRouteName(currentRoute.value.name as string);
    }
  );
});

onBeforeMount(async () => {
  oneTegVersion.value = await getParameter("ONETEG_VERSION");
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(selectedBreadcrumb), (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: item,
            class: _normalizeClass({ last: index === _unref(selectedBreadcrumb).length - 1 })
          }, [
            _createVNode(_unref(ElTooltip), {
              effect: "custom",
              content: item.isTranslated ? _unref(t)(item.labelKey) : item.uniqueLabel,
              placement: "bottom"
            }, {
              default: _withCtx(() => [
                _createElementVNode("a", {
                  onClick: ($event: any) => (item.disabled ? '' : _unref(router).push(item.route)),
                  class: _normalizeClass({
                last: index === _unref(selectedBreadcrumb).length - 1,
                'breadcrumb-item-label': true,
              })
                }, _toDisplayString(item.isTranslated ? _unref(t)(item.labelKey) : item.uniqueLabel), 11, _hoisted_4)
              ]),
              _: 2
            }, 1032, ["content"])
          ], 2))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("ul", _hoisted_6, [
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("a", {
            class: "nav-link label a-class helpLink",
            href: helpUrl,
            target: "_blank"
          }, [
            _createVNode(_component_font_awesome_icon, { icon: "info-circle" }),
            _createTextVNode(" Help")
          ])
        ]),
        _createElementVNode("li", _hoisted_8, [
          _createElementVNode("a", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, { icon: "building" }),
            _createTextVNode(" " + _toDisplayString(_unref(selectedOrganizationRole) && _unref(selectedOrganizationRole).organization
                ? _unref(selectedOrganizationRole).organization.name
                : "Select an organization"), 1)
          ]),
          _createElementVNode("ul", _hoisted_10, [
            _createElementVNode("li", null, [
              _createVNode(_unref(ElInput), {
                id: "org-switcher-search",
                modelValue: searchQuery.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((searchQuery).value = $event)),
                placeholder: _unref(t)('Header.SearchAnOrganization'),
                size: "mini",
                style: {"padding":"0px 5px"}
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _hoisted_11,
            (filteredOrganizationRoles.value.length === 0)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                  _createElementVNode("a", _hoisted_13, _toDisplayString(_unref(t)("Header.NoOrganizationsFound")), 1)
                ]))
              : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(filteredOrganizationRoles.value, (organizationRole) => {
                  return (_openBlock(), _createElementBlock("li", {
                    key: organizationRole.id
                  }, [
                    _createElementVNode("a", {
                      class: "dropdown-item a-class",
                      onClick: ($event: any) => (handleChangeOrganization(organizationRole))
                    }, _toDisplayString(organizationRole.organization.name) + " " + _toDisplayString(organizationRole.role.name), 9, _hoisted_14)
                  ]))
                }), 128))
          ])
        ]),
        _createElementVNode("li", _hoisted_15, [
          _createElementVNode("a", _hoisted_16, [
            _createVNode(_component_font_awesome_icon, { icon: "user" })
          ]),
          _createElementVNode("ul", _hoisted_17, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(router).push('/user-preferences')))
            }, [
              _createElementVNode("a", _hoisted_18, _toDisplayString(_unref(t)("Preferences.Preferences")), 1)
            ]),
            _hoisted_19,
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_20, _toDisplayString(_unref(authInfo)?.username), 1)
            ]),
            _hoisted_21,
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_22, "Role: " + _toDisplayString(_unref(selectedOrganizationRole) && _unref(selectedOrganizationRole).role
                    ? _unref(selectedOrganizationRole).role.authority
                    : "Select an organization"), 1)
            ]),
            _hoisted_23,
            _createElementVNode("li", null, [
              _createElementVNode("a", _hoisted_24, _toDisplayString(_unref(t)("Auth.version")) + " " + _toDisplayString(version.value), 1)
            ]),
            _hoisted_25,
            _createElementVNode("li", { onClick: handleLogOut }, [
              _createElementVNode("a", _hoisted_26, [
                _createVNode(_component_font_awesome_icon, { icon: "sign-out-alt" }),
                _createTextVNode("  " + _toDisplayString(_unref(t)("Auth.LogOut")), 1)
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})